// extracted by mini-css-extract-plugin
module.exports = {"Container":"ResultsList_Container__Px4je","ShowMore":"ResultsList_ShowMore__3RcRJ","Error":"ResultsList_Error__yVRW2"};